import React from "react";
import { JSX } from "react/jsx-runtime";

const MessageIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7.8 7.8H19.7M7.8 14.6H14.6M14.1565 21.1043L7.06087 28.2V21.1043H4.4C2.52223 21.1043 1 19.5821 1 17.7043V4.4C1 2.52223 2.52223 1 4.4 1H24.8C26.6778 1 28.2 2.52223 28.2 4.4V17.7043C28.2 19.5821 26.6778 21.1043 24.8 21.1043H14.1565Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
export default MessageIcon;